const sinceYear = 2020;
const sinceMonth = "05";

const generatePeriods = () => {
  const getYearsRange = (end) => {
    const years = [];
    // eslint-disable-next-line no-plusplus
    for (let year = sinceYear; year <= end; year++) {
      years.push(year);
    }
    return years;
  };
  const months = ["01", "02", "03", "04", "05", "06", "07", "08", "09", "10", "11", "12"];
  const currentYear = new Date().getFullYear();
  const yearsRange = getYearsRange(currentYear);
  const monthsYearsRange = yearsRange
    .map((year) => months.map((month) => `${month}/${year}`))
    .flat();
  const sincePeriodIndex = monthsYearsRange.findIndex((my) => my === `${sinceMonth}/${sinceYear}`);

  return monthsYearsRange.slice(sincePeriodIndex).reverse();
};

export default generatePeriods;
